@use "variables" as *;

.container {
  position: relative;
  width: 100%;
  display: flex;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: $spacing-m;
    top: 0;
    bottom: 0;
    margin: auto 0;
    align-items: center;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.hoverButton {
  width: 24px;
  height: 24px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.hoverButtonIcon {
  width: 16px !important;
  height: 16px !important;
}

.shelving {
  width: 25%;
  font-size: $fontSize-s;
  flex-shrink: 0;
  font-variant: tabular-nums;
}

.labelStack {
  width: 25%;
  flex-shrink: 0;
}

.topLabel {
  font-size: $fontSize-xxs;
  font-weight: normal;
  font-variant: tabular-nums;
}

.bottomLabel {
  font-size: $fontSize-s;
  font-weight: normal;
  font-variant: tabular-nums;
}

.position {
  width: 25%;
  font-size: $fontSize-xs;
  font-weight: normal;
  text-align: center;
  flex-shrink: 0;
  font-variant: tabular-nums;
  white-space: pre-wrap;
}
